import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

import * as model from "../models";
import { UnsafeAction } from "./UnsafeAction"

/* tslint:disable */
@Injectable()
export class EventActions {

	static CLEAR_STATE = "[Event] Clear State";
	clearState(): Action {
		return {
			type: EventActions.CLEAR_STATE
		}
	}

	static EVENT_LOADED = "[Event] Event loaded";
	eventLoaded(event: model.Event): UnsafeAction {
		return {
			type: EventActions.EVENT_LOADED,
			payload: event
		}
	}

	static UPDATE_EVENT_HAS_VISUAL_QUOTA_SUCCESS = '[Event] Update Event has visual Quota Success'
	updateEventHasVisualQuotaSuccess(): Action {
		return {
			type: EventActions.UPDATE_EVENT_HAS_VISUAL_QUOTA_SUCCESS,
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/actions/event.actions.ts